import React, { FC } from 'react'

import { FormattedMessage } from 'react-intl'

import { GQLGender } from 'generated-graphql/graphql'

export const SeenRecentlyText: FC<{ gender: GQLGender | string }> = ({
  gender,
}) => {
  return (
    <FormattedMessage
      id="geolocation.seen.recently"
      defaultMessage="{gender, select, M {Был} F {Была} other {Был}} недавно"
      values={{ gender }}
    />
  )
}
